import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InfoIdentidad } from '../../../../models/info-Identidad';
import { ConfigDataService } from '../../../../services/config-data.service';
import {MyValidations} from '../../../../utils/my-validations';

@Component({
  selector: 'app-info-identidad-detalle',
  templateUrl: './info-identidad-detalle.component.html',
  styleUrls: ['./info-identidad-detalle.component.css']
})
export class InfoIdentidadDetalleComponent implements OnInit, AfterViewInit {
  
  constructor(private fb: FormBuilder, 
              private configDataSrv: ConfigDataService) { }

  @Input() set infoIdentidad(infoIdentidadRecibida: InfoIdentidad)
  {
    this.infoIdentidadForm = infoIdentidadRecibida;
    this.setearForm(infoIdentidadRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() infoIdentidadesInvalida: boolean;

  form: FormGroup;
  infoIdentidadForm: InfoIdentidad;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  formHabilitado: boolean;
  clasesDocList: any;
  paisesList: any;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.configDataSrv.getDatosInfoIdentidad()
      .subscribe(
        data => {
          this.paisesList=data["Paises"];
          this.clasesDocList=data["ClaseDocumentos"];
        },
        error => {
          console.log(error);
        });

    this.configurarValidadores();
    this.setearForm(this.infoIdentidadForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      claseDocumento: ['', Validators.required],
      docNro: ['', Validators.required],
      fechaEmision: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      lugarEmision: ['', Validators.required],
      nroEmision: ['', Validators.required],
      paisEmisor: ['', Validators.required],
      autoridad: ['', Validators.required],
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(infoIdentidad: InfoIdentidad)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(infoIdentidad?.id);
      this.form.controls['desde'].setValue(new Date(infoIdentidad?.desde));
      this.form.controls['hasta'].setValue(new Date(infoIdentidad?.hasta));
      this.form.controls['personal'].setValue(infoIdentidad?.personal);
      this.form.controls['claseDocumento'].setValue(infoIdentidad?.claseDocumento);
      this.form.controls['docNro'].setValue(infoIdentidad?.docNro);
      if (infoIdentidad?.fechaEmision != null) {
        this.form.controls['fechaEmision'].setValue(new Date(infoIdentidad?.fechaEmision));
      }
      if (infoIdentidad?.fechaValidez != null) {
        this.form.controls['fechaValidez'].setValue(new Date(infoIdentidad?.fechaValidez));
      }
      this.form.controls['lugarEmision'].setValue(infoIdentidad?.lugarEmision);
      this.form.controls['nroEmision'].setValue(infoIdentidad?.nroEmision);
      this.form.controls['paisEmisor'].setValue(infoIdentidad?.paisEmisor);
      this.form.controls['autoridad'].setValue(infoIdentidad?.autoridad);

      if (infoIdentidad.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
  }

  
}

